import { z } from 'zod';

export const DEVICE_CONTROL_COMMANDS = [
  'keepAlive',
  'listen',
  'releaseDoorLock1',
  'releaseDoorLock2',
  'releaseSafeLock',
  'resetSpeechSettings',
  'selectSpeaker1',
  'selectSpeaker2',
  'sendTones',
  'setVolumeLevel1',
  'setVolumeLevel2',
  'setVolumeLevel3',
  'speak',
  'switchToDuplex',
  'switchToSimplex',
  'volumeDown',
  'volumeUp',
  'testAlarm',
] as const;

export const DeviceControlCommandSchema = z.enum(DEVICE_CONTROL_COMMANDS);
export type DeviceControlCommand = z.infer<typeof DeviceControlCommandSchema>;

export const DeviceControlMetaSchema = z.record(
  DeviceControlCommandSchema,
  z.object({ name: z.string() }),
);
export type DeviceControlMeta = z.infer<typeof DeviceControlMetaSchema>;

export const deviceControlMeta: DeviceControlMeta = {
  keepAlive: {
    name: 'Keep Alive',
  },
  listen: {
    name: 'Listen',
  },
  releaseDoorLock1: {
    name: 'Release Door Lock 1',
  },
  releaseDoorLock2: {
    name: 'Release Door Lock 2',
  },
  releaseSafeLock: {
    name: 'Release Safe Lock',
  },
  resetSpeechSettings: {
    name: 'Reset Speech Settings',
  },
  selectSpeaker1: {
    name: 'Select Speaker 1',
  },
  selectSpeaker2: {
    name: 'Select Speaker 2',
  },
  sendTones: {
    name: 'Send Tones',
  },
  setVolumeLevel1: {
    name: 'Set Volume Level 1',
  },
  setVolumeLevel2: {
    name: 'Set Volume Level 2',
  },
  setVolumeLevel3: {
    name: 'Set Volume Level 3',
  },
  speak: {
    name: 'Speak',
  },
  switchToDuplex: {
    name: 'Switch To Duplex',
  },
  switchToSimplex: {
    name: 'Switch To Simplex',
  },
  volumeDown: {
    name: 'Volume Down',
  },
  volumeUp: {
    name: 'Volume Up',
  },
  testAlarm: {
    name: 'Test Alarm',
  },
} as const;
